import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const TABS = [
  { label: "All", to: "/shop" },
  { label: "Tops", to: "/tops" },
  { label: "Bottoms", to: "/bottoms" },
  { label: "Accessories", to: "/accessories" },
];

export default function Shop({ title = "Shop" }) {
  const location = useLocation();
  return (
    <motion.main
      data-testid="shop-page"
      className="pt-14"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <nav className="flex items-center justify-center gap-6 border-b border-neutral-100 px-4 py-3">
        {TABS.map((tab) => {
          const active = location.pathname === tab.to;
          return (
            <Link
              key={tab.to}
              to={tab.to}
              data-testid={`shop-tab-${tab.label.toLowerCase()}`}
              className={`text-xs transition-colors ${
                active ? "font-semibold text-neutral-900 underline underline-offset-4" : "text-neutral-500 hover:text-neutral-900"
              }`}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>
      <h1 className="mt-8 text-center text-lg font-semibold text-neutral-900">{title}</h1>
      <div className="flex min-h-[45vh] items-center justify-center px-6">
        <p data-testid="shop-empty-state" className="max-w-xs text-center text-sm leading-relaxed text-neutral-500">
          We don&apos;t have any products to show here right now.
        </p>
      </div>
    </motion.main>
  );
}
